import { useCallback, useMemo } from 'react';
import { analytics } from './index';
import type { EventProperties, UserTraits } from './index';

/**
 * React hook for analytics
 * Returns memoized track/identify/etc functions
 */
export function useAnalytics() {
  const track = useCallback((event: string, properties?: EventProperties) => {
    analytics.track(event, properties);
  }, []);

  const identify = useCallback((userId: string | null, traits?: UserTraits) => {
    analytics.identify(userId, traits);
  }, []);

  const reset = useCallback(() => {
    analytics.reset();
  }, []);

  const page = useCallback((pageName: string, properties?: EventProperties) => {
    analytics.page(pageName, properties);
  }, []);

  return useMemo(
    () => ({
      track,
      identify,
      reset,
      page,
    }),
    [track, identify, reset, page],
  );
}
